import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepOneExtraCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepOneExtraCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) =>
    state.findWordsStepOneExtraCollections.data
      .findWordsStepOneExtraCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepOneExtraCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
